import React, { useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { Box } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

interface RequestPayoffProps {
  onChange: (data: { effectiveDate: string | null }) => void;
}

const RequestPayoff: React.FC<RequestPayoffProps> = ({ onChange }) => {
  const [effectiveDate, setEffectiveDate] = useState<Dayjs | null>(dayjs());

  React.useEffect(() => {
    onChange({ effectiveDate: effectiveDate ? effectiveDate.format('YYYY-MM-DD') : null });
  }, [effectiveDate]);

  return (
    <Box sx={{ width: "50%" }}>
      <DatePicker
        label="Effective Date"
        value={effectiveDate}
        onChange={setEffectiveDate}
        slotProps={{ textField: { fullWidth: true, size: 'medium', margin: 'normal', focused: true, inputProps: {'data-testid': "asset-payoff-effective-date-picker"} } }}
      />
    </Box>
  );
};

export default RequestPayoff;
